var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 888 722",
    style: {
      enableBackground: "new 0 0 888 722"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#169597;}\r\n\t.st1{display:none;fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#DB3827;}\r\n\t.st4{fill:#F93A3A;stroke:#000000;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.7,652c29.8,0,59.5,0,89.3,0c0.5-84.1,1-168.2,1.5-252.3C297,413.5,243.5,427.2,190,441 C213.2,511.3,236.5,581.7,259.7,652z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible",
      opacity: 0.6,
      enableBackground: "new"
    },
    width: 583,
    height: 478,
    xlinkHref: "67D8217E.png",
    transform: "matrix(1.431 0 0 1.4425 72 -5)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56,76l272.3,5.7l181.5,162c9.4,8.6,18.8,17.1,28.3,25.7c-66.6,25.4-133.1,50.8-199.7,76.2 c-52.8,19.7-105.5,39.4-158.3,59.1C138.7,295.2,97.3,185.6,56,76z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.5,261.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.5,261.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.5,261.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M640.5,303.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.5,85.5c90,1.7,180,3.3,270,5c175,166,350,332,525,498c0.9,7.2,1.1,16.8-1.1,27.6 c-5.4,26-21.8,42.2-28.9,48.4l-559-6L85.5,85.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.5,85.5c90,1.7,180,3.3,270,5c175,166,350,332,525,498c0.9,7.2,1.1,16.8-1.1,27.6 c-5.4,26-21.8,42.2-28.9,48.4l-559-6L85.5,85.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.5,148.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.5,138.5l159,190.4c-49.5,25.3-99,50.6-148.5,75.9c3.3,12.1,6.6,24.1,10,36.2 c53.5-13.8,107-27.5,160.5-41.3c-0.5,84.1-1,168.2-1.5,252.3c19.5-0.5,39-1,58.5-1.5c23.7-95.6,47.3-191.1,71-286.7 c0,0,172-62.8,164-116.7s-202,31.9-202,31.9l-235-146.6L169.5,138.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 473.5,
    y: 311.5,
    className: "st1",
    width: 6,
    height: 6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.5,398.5c0,0,256-93,292-123c0,0-249,101-292,120S316.5,398.5,316.5,398.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M608.5,282.5c0,0-115,60-221,96C387.5,378.5,504.5,349.5,608.5,282.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M608,232c6.5,0.9,18.6,2.7,24,12c3.5,6,2.5,12.5,2,16c-0.6,4-2.7,13.3-21,31c-4.6,4.4-13.5,12.6-26.5,21.5 c-11.1,7.6-20.6,12.5-35,20c-2,1-8.1,4.2-16,8c-12.5,6-31.5,14.6-57,24c-23.7,95.3-47.3,190.7-71,286l417,6c0,0,44-30,30-78 c-88-85.3-176-170.7-264-256c42.2-31.3,64.2-63.3,56-80c-1.8-3.7-6.3-9-19-12c-1.4-0.2-3.1-0.4-5-0.6c0,0-3.2-0.3-6.3-0.4 c-9.4-0.4-23.2,1.5-23.2,1.5c-10,1.4-15,2-24,4c-15.9,3.4-59.1,16.8-59,17c0,0.1,16.1-6,41-12c11.4-2.8,17.9-3.8,31-6 C598.1,231.3,602.8,231.3,608,232z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M683.5,294.5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M636.5,319.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M479.4,297.7l-15.3,5.7c-1.7,0.6-3.6-0.2-4.3-2l-2.2-5.9c-0.6-1.7,0.2-3.6,2-4.3l15.3-5.7 c1.7-0.6,3.6,0.2,4.3,2l2.2,5.9C482,295.1,481.1,297.1,479.4,297.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M507.2,285.6l-15.3,5.7c-1.7,0.6-3.6-0.2-4.3-2l-2.2-5.9c-0.6-1.7,0.2-3.6,2-4.3l15.3-5.7 c1.7-0.6,3.6,0.2,4.3,2l2.2,5.9C509.8,283,509,284.9,507.2,285.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M535.2,274.6l-15.3,5.7c-1.7,0.6-3.7-0.2-4.3-2l-2.2-5.9c-0.7-1.7,0.2-3.6,2-4.3l15.3-5.7 c1.7-0.6,3.7,0.2,4.3,2l2.2,5.9C537.8,272,537,273.9,535.2,274.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M564.2,263.6l-15.3,5.7c-1.7,0.6-3.7-0.2-4.3-2l-2.2-5.9c-0.7-1.7,0.2-3.6,2-4.3l15.3-5.7 c1.7-0.6,3.7,0.2,4.3,1.9l2.2,5.9C566.8,261,566,262.9,564.2,263.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M575,245c2,5.3,4,10.7,6,16c2.7-1.1,8.8-3.7,14-7c1.3-0.8,2.9-1.9,4-4c1-1.9,1.1-3.9,1-5c-0.2-0.5-0.4-1.3-1-2 c-0.4-0.5-2.4-2.7-10-2C585.8,241.3,580.8,242.2,575,245z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M451.2,309l-15.3,5.7c-1.7,0.6-3.6-0.2-4.3-2l-2.2-5.9c-0.6-1.7,0.2-3.6,2-4.3l15.3-5.7c1.7-0.6,3.6,0.2,4.3,2 l2.2,5.9C453.8,306.5,453,308.4,451.2,309z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M548,238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M673,293"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M380,600"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.5,541.9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M355,663"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.7,393.3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-112,394"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9855ffb34aa6d257f25d97b523f9076e.svg";
export { ForwardRef as ReactComponent };